const RejectValidation = ({ reason }) => {
  const errors: any = {};
  if (!reason) {
    errors.reason = 'Catatan wajib diisi';
  }
  return errors;
};
export default RejectValidation;
